import { jsx as _jsx } from "react/jsx-runtime";
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { TableVirtualizer as TanStackTable } from '../TableVirtualizer';
import { RemoteVersionSelectorRenderer } from './RemoteVersionSelectorRenderer';
const columnHelper = createColumnHelper();
function getColumns(param) {
    let { organization, project, application, appVersion } = param;
    if (!organization || !project || !application || !appVersion) {
        return [];
    }
    return [
        columnHelper.accessor('name', {
            header: ()=>'Name',
            cell: (inf)=>inf.getValue()
        }),
        columnHelper.accessor('version', {
            header: ()=>'Versions',
            cell: (inf)=>{
                var _appVersion_remotes;
                return /*#__PURE__*/ _jsx(RemoteVersionSelectorRenderer, {
                    value: inf.getValue(),
                    organization: organization,
                    project: project,
                    application: application,
                    appVersion: appVersion,
                    applicationRemotes: (_appVersion_remotes = appVersion.remotes) !== null && _appVersion_remotes !== void 0 ? _appVersion_remotes : []
                });
            }
        })
    ];
}
function convertToRowData(appVersion) {
    var _appVersion_consumes;
    if (!appVersion) {
        return [];
    }
    const applicationsNames = Array.from(((_appVersion_consumes = appVersion.consumes) !== null && _appVersion_consumes !== void 0 ? _appVersion_consumes : []).reduce((s, consumed)=>{
        if (consumed.applicationID) {
            s.add(consumed.applicationID);
        }
        return s;
    }, new Set()));
    return applicationsNames.map((applicationName)=>({
            name: applicationName,
            version: applicationName
        }));
}
export function RemoteCurrentVersion(props) {
    const columnDefs = useMemo(()=>getColumns(props), [
        props
    ]);
    const rowData = useMemo(()=>convertToRowData(props.appVersion), [
        props.appVersion
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col gap-4",
        children: /*#__PURE__*/ _jsx(TanStackTable, {
            data: rowData,
            columns: columnDefs
        })
    });
}
